<div class="currency-wallet" #currencyWalletWrapper>
  <div class="expansion-row">
    <div class="contants-row onact96" (click)="handleOpen()" [class.diasbled]="isDiasbled">
      <!--用户金额-->
      <ng-container *ngIf="!defaultCurrencyLoading">
        <div class="amount">
          <ng-container *ngIf="currentCurrencyData">
            <img class="currency-icon" [src]="currentCurrencyData.icon" />
            @if (isShowPlaying) {
              <span class="play-in">In Play</span>
            } @else {
              <span #amount>
                {{
                  currencyWalletService.balanceFormat(
                    allCurrencyBalance
                      | filterByKeyValue: 'currency' : currentCurrencyData.currency : 'nonStickyBalance',
                    currentCurrencyData.currency,
                    { hasCurrency: displayInFiat }
                  )
                }}
              </span>
            }
          </ng-container>
        </div>
        <i class="select-icon fi-cheveron-down" [class.active]="supportExpanded"></i>
      </ng-container>
      <i class="animation-icon-loading-dot" *ngIf="defaultCurrencyLoading"><i></i><i></i><i></i></i>
    </div>
    <div class="toggle mutual-opacity onact96" [class.disabled]="renderPiqCheckedLoading()" (click)="toWalletPage()">
      <i class="fi-plus-chunky"></i>
    </div>
  </div>
</div>

<!--币种切换tab-->
<ng-template #currencySettingsDialog>
  <div class="currency-settings-dialog" @expansion>
    @if (layoutService.isH5$ | async) {
      <div class="expansion-title">
        Select currency

        <cs-icon-button
          [iconType]="'icon'"
          [icon]="'fi-x'"
          [frameShape]="'square'"
          [color]="'secondary'"
          [size]="'24'"
          [iconFontSize]="'12'"
          (buttonClick)="supportExpanded = false"
        ></cs-icon-button>
      </div>
    }

    <div class="expansion-header">
      <cs-input
        [prefixIconName]="'fi-search'"
        [placeholder]="('search_currency' | translate) || 'Search'"
        [maxLength]="40"
        [(value)]="searchKeyWord"
        [marginBottom]="'0'"
      />
      <!-- <div class="tabs">
          <div
            class="tab offset-right onact96-not"
            [class.active]="selectedTabIndex === 0"
            (click)="selectedTabIndex = 0; piqService.selectDepositMethod.set('crypto')"
          >
            {{ 'crypto' | translate }}
          </div>
          <div
            class="tab onact96-not"
            [class.active]="selectedTabIndex === 1"
            (click)="selectedTabIndex = 1; piqService.selectDepositMethod.set('fiat')"
          >
            {{ 'fiat_cur' | translate }}
          </div>
        </div> -->
    </div>

    <div class="expansion-body">
      @if (
        (checkZeroCurrencies | filterByText: searchKeyWord : ['currency'] | filterByKeyValue: 'isDigital' : true)
          .length === 0
      ) {
        <app-empty
          [style.padding]="'var(--lg) var(--md)'"
          [title]="'Your Wallet is Empty'"
          [message]="'Looks like you haven\'t added any funds yet'"
        ></app-empty>
      } @else {
        @for (
          item of checkZeroCurrencies
            | filterByText: searchKeyWord : ['currency']
            | filterByKeyValue: 'isDigital' : true;
          track $index
        ) {
          <cs-standard-tab
            [ngClass]="{
              onact96: true,
              'grid-layout':
                allCurrencyBalance
                | filterByText: searchKeyWord : ['currency']
                | filterByKeyValue: 'currency' : item.currency : 'isShowNonSticky',
            }"
            (click)="$event.stopPropagation(); handleSelect(item)"
          >
            <div class="rate-clounm">
              <img [src]="item.icon" />
              <span>{{ item.currency }}</span>
            </div>

            <div class="amount-value">
              @if (displayInFiat && item.isDigital) {
                <!-- {{
                    (currencies
                      | filterByText: searchKeyWord : ['currency']
                      | filterByKeyValue: 'currency' : inFiatConvertType : 'symbol') || ''
                  }} -->
                {{
                  currencyWalletService.amountAfterCalculateRate(
                    allCurrencyBalance
                      | filterByText: searchKeyWord : ['currency']
                      | filterByKeyValue: 'currency' : item.currency : 'nonStickyBalance',
                    item.currency
                  ) | currencyValue: inFiatConvertType
                }}
                {{ inFiatConvertType }}
              } @else {
                {{
                  (item.isDigital
                    ? ''
                    : (currencies
                        | filterByText: searchKeyWord : ['currency']
                        | filterByKeyValue: 'currency' : item.currency : 'symbol') || '') +
                    (allCurrencyBalance
                      | filterByText: searchKeyWord : ['currency']
                      | filterByKeyValue: 'currency' : item.currency : 'nonStickyBalance'
                      | currencyValue: item.currency)
                }}
              }
            </div>
          </cs-standard-tab>
        }
      }
    </div>

    <div class="expansion-footer">
      <div class="wallet-summary">
        <div class="wallet-summary-row">
          <div class="wallet-summary-label">Bonus</div>
          <div class="wallet-summary-value">
            <app-assets-value
              [value]="lockBonus"
              [currentCurrency]="currentCurrencyData.currency || 'USDT'"
              [currentCurrencyIcon]="currentCurrencyData.icon || ''"
              [displayInFiat]="displayInFiat"
            />
          </div>
        </div>

        <div class="wallet-summary-row">
          <div class="wallet-summary-label">Total balance</div>
          <div class="wallet-summary-value">
            <app-assets-value
              [value]="totalAsset"
              [currentCurrency]="currentCurrencyData.currency || 'USDT'"
              [currentCurrencyIcon]="currentCurrencyData.icon || ''"
              [displayInFiat]="displayInFiat"
            />
          </div>
        </div>
      </div>

      <div class="wallet-settings">
        <app-fiat-display-switch (fiatSelectionBtnClick)="supportExpanded = false" />
        <cs-switch
          label="Hide zero balances"
          [(ngModel)]="hideZero"
          (ngModelChange)="currencyWalletService.hideZero$.next($event)"
        />
      </div>
    </div>
  </div>
</ng-template>
